import { Button, Divider, List, message } from "antd"
import AddEditTeamMemberModal from "./modals/AddEditTeamMemberModal"
import DeleteModalSimple from "./DeleteModalSimple"
import { useEffect, useMemo, useState } from "react";
import TeamMemberItem from "./TeamMemberItem";
import { deleteTeamMember, getUserByPartner, inviteTeamMember } from "../../../API/endpoints/User";
import NoDataIcon from "../../../components/icons/NoDataIcon";
import InfiniteScroll from "react-infinite-scroll-component";
import SectionLoader from "./SectionLoader";
import { GetOrgUsers } from "../../../API/endpoints/Organization";

interface Props {
    orgId?: string;
    partnerId?: string;
}
const TeamMembers = (props: Props) => {
    const { orgId, partnerId } = props;
    const [messageApi, contextHolder] = message.useMessage()

    const [isAddMember, setIsAddMember] = useState(false);
    const [isDeleteItem, setIsDeleteItem] = useState<any>({})
    const [isEditMember, setIsEditMember] = useState<any>({});

    const [list, setList] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const [reload, setReload] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalCount, setTotalCount] = useState(1);

    useEffect(() => {
        if (orgId) {
            setLoading(true)
            GetOrgUsers(orgId, pageNumber).then((res: any) => {
                if (pageNumber > 1) {
                    setList([...list, ...res?.data?.rows]);
                } else {
                    setList(res?.data?.rows || []);
                }

                setTotalCount(res?.data?.count);
                setLoading(false)
            }).catch((err) => {
                setLoading(false)
            })
        }

        if (partnerId) {
            setLoading(true)
            getUserByPartner(partnerId).then((res: any) => {
                const data = res.data.rows || []
                setList(data);

                setTotalCount(data?.length);
                setLoading(false)
            }).catch((err) => {
                setLoading(false)
            })
        }

    }, [orgId, partnerId, pageNumber, reload])

    const reInviteUser = (id: string) => {
        const req = {
            id: id
        }
        inviteTeamMember(req).then((res) => {
            messageApi.success("Invitation sent successfully")
        }).catch((err) => {
            messageApi.error("Failed to send the invitation")
            console.log('err', err);

        })
    }

    const onSuccessAddMember = () => {
        messageApi.success(isEditMember?.name ? "Updated team member successfully" : "Added new team member successfully");
        setIsEditMember({});
        setIsAddMember(false);
        setPageNumber(1);
        setReload(!reload)
    }

    const onCancelAddMember = () => {
        setIsEditMember({});
        setIsAddMember(false);
    }

    const onSuccessDeleteMember = () => {
        setList((prev: any[]) => prev.filter((item: any) => item?.id !== isDeleteItem?.id));
        setTotalCount((prev) => prev - 1)
        messageApi.success("Deleted the team member successfully");
        setIsDeleteItem({});
    }

    const actionOptions = (record: any) => {
        let items: any = [];
        items.push(
            {
                key: '1',
                label: "Edit user",
                onClick: () => {
                    setIsEditMember(record);
                    setIsAddMember(true);
                }
            }
        )

        if (!record?.is_active) {
            items.push(
                {
                    key: '2',
                    label: "Resend invite",
                    onClick: () => reInviteUser(record?.id)
                }
            )
        }

        items.push({
            key: '3',
            danger: true,
            label: "Delete user",
            onClick: () => setIsDeleteItem(record)
        })

        return items;
    }

    const teamMembersList = useMemo(() => {
        return (
            <InfiniteScroll
                dataLength={list.length}
                next={() => {
                    setPageNumber((prev) => prev + 1)
                }}
                hasMore={list.length < totalCount}
                loader={(
                    loading ? <SectionLoader className="h-[53px]" /> : <></>
                )
                }
                endMessage={loading ? <SectionLoader className="h-[53px]" /> : !partnerId ? <Divider plain>That's all.</Divider> : <></>}
                scrollableTarget="scrollableDiv"

            >
                <List
                    dataSource={list}
                    renderItem={(item: any) => (
                        <TeamMemberItem data={item} key={item?.id} onDelete={() => setIsDeleteItem(item)} actionOptions={actionOptions} disableEdit={Boolean(partnerId)}/>
                    )}
                    locale={{
                        emptyText: (
                            !loading ? (
                                <div className="w-full h-full flex flex-col items-center">
                                    <NoDataIcon />
                                </div>
                            ) : (
                                <></>
                            )

                        ),
                    }}
                />
            </InfiniteScroll>
        )
        // return teamMembers.map((item: any) => {
        //     return <TeamMemberItem data={item} key={item?.id} onDelete={() => setIsDeleteItem(item)} actionOptions={actionOptions} />
        // })
    }, [list, totalCount])

    return (
        <div className="rounded-[8px] p-[16px] bg-white">
            {contextHolder}
            <div className="mb-[16px] flex items-center justify-between">
                <p className="text-[13px] font-[600] m-0">Team</p>
                {orgId ? (
                    <Button type="primary" size="small" className="text-[12px] leading-[12px]" onClick={() => setIsAddMember(true)}>Add</Button>
                ) : (
                    <></>
                )}

            </div>

            <div className="flex flex-col gap-y-[10px] overflow-auto h-[calc(100vh-320px)]" id="scrollableDiv">
                {teamMembersList}
            </div>
            <AddEditTeamMemberModal
                open={isAddMember}
                editData={isEditMember}
                orgId={orgId}
                onCancel={() => onCancelAddMember()}
                onSuccess={() => onSuccessAddMember()}
            />
            <DeleteModalSimple
                title="Team Member"
                item={isDeleteItem}
                onCancel={() => setIsDeleteItem({})}
                onSuccess={() => onSuccessDeleteMember()}
                api={deleteTeamMember}
            />
        </div>
    )
}

export default TeamMembers